/*
 * @Author: zhang lin
 * @Date: 2022-04-12 10:01:03
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-06-02 17:43:52
 * @Description: file content
 */
import request from 'root/utils/request';

// =>登录接口

interface PayloadType {
  account: string;
  password: string;
}

const basePath = '/api/ops-manager/v1/supos/login';

// 用户登录
export const login = async (payload: PayloadType) => {
  return request.post(`${basePath}`, payload);
};

// 用户登出
export const logout = async () => {
  return request.put(`${basePath}/logout`);
};

// 修改密码
export const updatePassword = async (payload: any) => {
  return request.post(`${basePath}/update/password`, payload);
};
